/** @file The WebSocket URL of a project on the page's origin (/ws/:projectId, wss: under https:). */

/** `wss://host/ws/<id>` under https, `ws://host/ws/<id>` otherwise (the Vite dev proxy forwards /ws). */
export function wsUrl(projectId: string, location: { protocol: string; host: string }): string {
  return `${location.protocol === 'https:' ? 'wss:' : 'ws:'}//${location.host}/ws/${encodeURIComponent(projectId)}`;
}
